import Button from '../../generic/Button';

import styles from './ThanksStep.module.less';

type Props = {
  onClose: () => void;
};

/**
 * Post-step rendered after the last question in the onboarding `SurveyWizard`.
 * Shows a confirmation message; the Done button calls `onClose` so the
 * fullscreen takeover dismisses (typically `setActiveSurvey(null)` in the
 * gating component).
 */
export const ThanksStep = ({ onClose }: Props) => (
  <div className={styles.step}>
    <h2 className={styles.heading}>Thanks!</h2>
    <p className={styles.body}>Your responses help us improve FOSSA.</p>
    <Button onClick={onClose}>
      Done
    </Button>
  </div>
);
